<template>
  <div>
    <div>
      <div class="pb-4">
        <v-btn @click="all"> Show all check-in's </v-btn>
        <v-btn @click="none" class="float-right">
          Close all check-in's
        </v-btn>
      </div>
    </div>
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel v-for="(assessment, index) in userCheckIns" :key="assessment.node.id">
        <v-expansion-panel-header class="title">
          <template v-slot:default="{ open }">
            <v-row>
              <v-col cols="4">
                <p>{{ assessmentDate(assessment) }}</p>
                <div class="d-flex justify-space-between">
                  <v-tooltip v-if="assessment.node.type == 'USER'" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="blue" :size="30" v-bind="attrs" v-on="on">mdi-account-outline</v-icon>
                    </template>
                    <span>User check-in</span>
                  </v-tooltip>
                  <v-tooltip v-else bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="green" :size="30" v-bind="attrs" v-on="on">mdi-account-multiple-outline</v-icon>
                    </template>
                    <span>Coaching check-in</span>
                  </v-tooltip>
                  <span v-if="!open && assessment.node.notes.length > 0" class="text-body-1 ml-2 grey-navy--text">
                    {{ assessment.node.notes.length }} note{{ assessment.node.notes.length > 1 ? "s" : "" }}
                  </span>
                  <div class="mr-4">
                    <ratings v-if="assessment.node.rating" :rating="assessment.node.rating" />
                    <ratings
                      v-if="assessment.node.nutritionRating"
                      :rating="assessment.node.nutritionRating"
                      icon="mdi-food-apple"
                      color="green"
                    />
                  </div>
                  <div v-if="assessment.node.type != 'USER' && !assessment.node.weight" class="mx-4 error--text">
                    (Incomplete)
                  </div>
                </div>
              </v-col>
              <v-col v-if="open" cols="8" class="pa-0 pr-5 mb-3 mt-auto">
                <div v-if="assessment.node.comments" class="text-body-1">Comment: <q>{{ assessment.node.comments }}</q></div>
                <div v-if="assessment.node.nutritionComments" class="text-body-1">Nutrition comment: <q>{{ assessment.node.nutritionComments }}</q></div>
              </v-col>
              <v-col v-else cols="8" class="pa-0 pr-5">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Weight (kg)</th>
                        <th class="text-left">Abdomen (cm)</th>
                        <th class="text-left">Chest (cm)</th>
                        <th class="text-left">Hip (cm)</th>
                        <th class="text-left">Quad (cm)</th>
                        <th />
                        <th class="text-left">1 mile</th>
                        <th class="text-left">Push-ups</th>
                        <th class="text-left">Sit-ups</th>
                        <th class="text-left">Burpees / Chirpees</th>
                        <th class="text-left">Elbow plank</th>
                        <th class="text-left">Squat hold</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ assessment.node.weight || "-" }}</td>
                        <td>{{ assessment.node.abdomen || "-" }}</td>
                        <td>{{ assessment.node.chest || "-" }}</td>
                        <td>{{ assessment.node.hip || "-" }}</td>
                        <td>{{ assessment.node.quad || "-" }}</td>
                        <td />
                        <td>{{ assessment.node.oneMile | humanizeSeconds | removeSpaces }}</td>
                        <td>{{ assessment.node.pushUps || "-" }}</td>
                        <td>{{ assessment.node.sitUps || "-" }}</td>
                        <td>{{ assessment.node.burpeeChirpee || "-" }}</td>
                        <td>{{ assessment.node.elbowPlank || "-" }}</td>
                        <td>{{ assessment.node.squat || "-" }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mr-5">
            <v-col cols="3" class="blue-grey lighten-5">
              <assessment-notes
                ref="childNotes"
                :userId="userId"
                :assessment="assessment.node"
                @reload="reloadAssessments()"
              />
            </v-col>
            <v-col cols="9" class="pt-0">
              <div>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th />
                        <th class="text-left">Weight (kg)</th>
                        <th class="text-left">Abdomen (cm)</th>
                        <th class="text-left">Chest (cm)</th>
                        <th class="text-left">Hip (cm)</th>
                        <th class="text-left">Quad (cm)</th>
                        <th />
                        <th class="text-left">1 mile</th>
                        <th class="text-left">Push-ups</th>
                        <th class="text-left">Sit-ups</th>
                        <th class="text-left">Burpees / Chirpees</th>
                        <th class="text-left">Elbow plank</th>
                        <th class="text-left">Squat hold</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td />
                        <td>{{ assessment.node.weight || "-" }}</td>
                        <td>{{ assessment.node.abdomen || "-" }}</td>
                        <td>{{ assessment.node.chest || "-" }}</td>
                        <td>{{ assessment.node.hip || "-" }}</td>
                        <td>{{ assessment.node.quad || "-" }}</td>
                        <td />
                        <td>{{ assessment.node.oneMile | humanizeSeconds | removeSpaces }}</td>
                        <td>{{ assessment.node.pushUps || "-" }}</td>
                        <td>{{ assessment.node.sitUps || "-" }}</td>
                        <td>{{ assessment.node.burpeeChirpee || "-" }}</td>
                        <td>{{ assessment.node.elbowPlank || "-" }}</td>
                        <td>{{ assessment.node.squat || "-" }}</td>
                      </tr>
                      <tr v-if="index < userCheckIns.length - 1">
                        <td class="p-text px-0"><strong>Change since previous</strong></td>
                        <td>{{ assessment.node.deltas.weight | change }}</td>
                        <td>{{ assessment.node.deltas.abdomen | change }}</td>
                        <td>{{ assessment.node.deltas.chest | change }}</td>
                        <td>{{ assessment.node.deltas.hip | change }}</td>
                        <td>{{ assessment.node.deltas.quad | change }}</td>
                        <td />
                        <td>{{ assessment.node.deltas.oneMile | humanizeSeconds | removeSpaces }}</td>
                        <td>{{ assessment.node.deltas.pushUps | change }}</td>
                        <td>{{ assessment.node.deltas.sitUps | change }}</td>
                        <td>{{ assessment.node.deltas.burpeeChirpee | change }}</td>
                        <td>{{ assessment.node.deltas.elbowPlank | change }}</td>
                        <td>{{ assessment.node.deltas.squat | change }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="subtitle-1"
              ><h3 class="d-inline">Photos</h3>
              <span class="fake-link" @click="assessment.node.showPhotos = !assessment.node.showPhotos"
                >(View/Hide)</span
              >
            </v-col>
          </v-row>
          <v-row v-if="assessment.node.showPhotos">
            <v-col cols="4" align="center" justify="center">
              <div v-if="assessment.node.imgBack">
                <v-img class="grey lighten-2" :src="assessment.node.imgBack" />
                <v-btn class="mt-4" @click="download(assessment.node.imgBack, `back`)">
                  Download <v-icon color="secondary">save_alt</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <h4>No picture uploaded</h4>
              </div>
            </v-col>
            <v-col cols="4" align="center" justify="center">
              <div v-if="assessment.node.imgFront">
                <v-img class="grey lighten-2" :src="assessment.node.imgFront" />
                <v-btn class="mt-4" @click="download(assessment.node.imgFront, `front`)">
                  Download <v-icon color="secondary">save_alt</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <h4>No picture uploaded</h4>
              </div>
            </v-col>
            <v-col cols="4" align="center" justify="center">
              <div v-if="assessment.node.imgSide">
                <v-img class="grey lighten-2" :src="assessment.node.imgSide" />
                <v-btn class="mt-4" @click="download(assessment.node.imgSide, `side`)">
                  Download
                  <v-icon color="secondary">save_alt</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <h4>No picture uploaded</h4>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn @click="editAssessment(assessment.node)">Edit</v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div>
      <edit-assessment-form ref="editAssessment" :close="(editActive = false)" />
    </div>
  </div>
</template>

<script>
import { fancy_date } from "@/lib/fancy_date";
import AssessmentNotes from "@/components/client/blocks/progress/assessments/AssessmentNotes";
import FileDownloadMixin from "@/components/shared/mixins/FileDownloadMixin";
import EditAssessmentForm from "@/components/assessment/forms/EditAssessmentForm";
import Ratings from "@/components/shared/Ratings";

export default {
  name: "AssessmentList",
  mixins: [FileDownloadMixin],
  components: {
    AssessmentNotes,
    EditAssessmentForm,
    Ratings
  },
  props: {
    userId: {
      type: [String, Number],
      required: true,
    },
    userCheckIns: {
      typee: Array,
      default: [],
    },
  },
  data() {
    return {
      panel: [],
    };
  },
  filters: {
    removeSpaces(val) {
      return val.replace(" ", "");
    },
    change(val) {
      return val <= 0 ? val : `+${val}`;
    },
  },
  methods: {
    all() {
      this.panel = [...this.userCheckIns.map((k, i) => i)];
    },
    none() {
      this.panel = [];
    },
    assessmentDate(assessment) {
      return assessment.node.assessmentDate
        ? this.fancyDate(assessment.node.assessmentDate)
        : this.fancyDate(assessment.node.requiredDate);
    },
    reloadAssessments() {
      this.$apollo.queries?.userCheckIns?.refetch();
    },
    fancyDate(date) {
      return fancy_date(date, "ddd, D MMM YYYY");
    },
    editingNotes() {
      let editing = false;
      this.$refs.childNotes.forEach((notesComponent) => {
        if (notesComponent.currentlyEditing()) {
          editing = true;
          return;
        }
      });
      return editing;
    },
    editAssessment(assessment) {
      this.$refs.editAssessment.open(assessment);
    },
  },
  beforeRouteLeave(to, from, next) {
    let currentlyEditing = this.editingNotes();
    if (currentlyEditing) {
      let confirmed = confirm("You are about to leave unsaved note edits. Are you sure you want to leave?");
      if (confirmed) next();
    } else {
      next();
    }
  },
};
</script>
